<textarea
  name="exampleText"
  [attr.placeholder]="placeholder"
  [(ngModel)]="text"
  (blur)="onTouch()">
</textarea>


